
import * as Types from '@aeppic/types'
import Vue from '../../externals/vue.js'

import { EditableDocument } from '../../model'
import DynamicComponent from '../dynamic/dynamic-component' 
import editFunctions from '../utils/edit-ref-functions'
import createEventForwarders from '../utils/create-event-forwarders'

export default {
  /* tslint:disable */
  render () {
    const _vm=this;
    const _h=_vm.$createElement;
    const _c=_vm._self._c||_h;
    
    return (_vm.dynamicComponent?.id) ? _c(_vm.dynamicComponent.id,
      {
        key: _vm.componentKey,
        tag: 'component',
        style: _vm.isComponentManuallyHidden ? { display: 'none' } : undefined,
        props: {
          'Aeppic': _vm.Aeppic,
          'params': _vm.params,
          'layout': _vm.dynamicComponent.document,
          'hide-component': _vm.hideComponent,
          'show-component': _vm.showComponent,
          'is-component-hidden': _vm.isComponentManuallyHidden,
        },
        on: createEventForwarders(_vm._events, _vm)
      }) : _vm._e()
  },
  renderError(h, err) {
    return h('pre', { staticClass: 'ae-error', style: { color: 'red' }}, 'ae-layout:' + this.layoutId + ' ' +  err.stack)
  },
  staticRenderFns: [],
  /* tslint:enable */
  
  inject: ['getAeppicContext'],
  props: { 
    layoutId: String,
    params: Object,
    watchLayout: {
      type: Boolean,
      default: null
    },
    watchLayoutRevisions: {
      type: Boolean,
      default: null
    }
  },
  data() {
    const Aeppic = this.getAeppicContext('ae-layout-selector:-')

    return {
      Aeppic,
      dynamicComponent: null,
      refreshing: false,
      componentKey: 0,
      isComponentManuallyHidden: false,
    }
  },
  mounted() {
    this.Aeppic.setContextRootElement(this.$el)
    this.loadLayout()
  },
  updated() {
  },
  created: function() {
    // console.log('layout created')
    const isDeveloper = this.Aeppic.Account && this.Aeppic.Account.data.allowDevMode
    const watch = typeof this.watchLayout === 'boolean' ? this.watchLayout : isDeveloper
    const watchRevisions = typeof this.watchLayoutRevisions === 'boolean' ? this.watchLayoutRevisions : isDeveloper

    this.loadLayout = async () => {
      const id = this.layoutId
      const layoutDocument = await this.Aeppic.get(id)

      // Clean up old component if it exists
      if (this.dynamicComponent) {
        this.dynamicComponent.destroy()
      }

      if (layoutDocument) {
        this.Aeppic.renameContext(`ae-layout-selector:${id}:${layoutDocument?.data.name ?? '?'}`)
        
        // Create a NEW DynamicComponent instance
        this.dynamicComponent = new DynamicComponent('layout', this.Aeppic, {
          formId: 'layout-form',
          template: LAYOUT_COMPONENT_TEMPLATE,
          exposedSymbols: '$el, $refs, $listeners, locals, Aeppic, Math, DateTime, Anime, params, layout, $emit, $on, translate, watchParam, SharedContext, hideComponent, showComponent, isComponentHidden',
          watch,
          watchRevisions
        })
        
        // Load the document into the new component
        this.componentKey++
        await this.dynamicComponent.refresh(layoutDocument)
        
        // Increment key to force Vue to create a new component instance
      } else {
        this.Aeppic.context.updateName?.(`ae-layout-selector:${id}:-}`)
        this.componentKey++
        this.dynamicComponent = null
      }
    }

  },
  methods: {
    hideComponent() {
      this.isComponentManuallyHidden = true
    },
    showComponent() {
      this.isComponentManuallyHidden = false
    }
  },
  beforeDestroy() {
    if (this.dynamicComponent) {
      this.dynamicComponent.destroy()
    }
    this.Aeppic.release()
  },
  watch: {
    layoutId(id) {
      this.loadLayout()
    },
    // params: {
    //   deep: true,
    //   handler() {
    //     this.render()
    //   }
    // }
  }
}

const LAYOUT_COMPONENT_TEMPLATE = `{
  template: __TEMPLATE__,
  props: ['Aeppic', 'params', 'layout', 'hideComponent', 'showComponent', 'isComponentHidden'],
  data() {
    const Aeppic = this.Aeppic

    const self = this
    const locals = __NEW_LOCALS__
    const handlers = []

    let sharedContext = null

    const controllerVariables = {
      get $el() { return self.$el },
      get $refs() { return self.$refs },
      $listeners: self.$listeners,
      locals,
      Aeppic,
      get DateTime() { return Aeppic.DateTime },
      get Math() { return Aeppic.Math },
      get Anime() { return Aeppic.Anime },
      get params() { return self.params },
      get layout() { return self.layout },
      translate(...args) { return self.translate(...args)},
      watchParam(...args) { return self.watchParam(...args)},
      $emit(...args) { return self.$emit(...args) },
      $on(...args) { 
        self.$parent.$on(...args)
        self.$on(...args)

        handlers.push(args)
      },
      get SharedContext() {
        if (!self.$el) {
          // console.error('SharedContext is only available after the component is mounted')
          // throw new Error('SharedContext is only available after the component is mounted')
          return {}
        }

        if (!self.$el.parentNode) {
          // console.error('SharedContext is only available after the component is mounted and has a parent node')
          // throw new Error('SharedContext is only available after the component is mounted and has a parent node')
          return {}
        }

        if (!sharedContext) {
          sharedContext = Aeppic.SharedContext.forElement(self.$el)
        }

        return sharedContext
      },
      hideComponent() { return self.hideComponent() },
      showComponent() { return self.showComponent() },
      get isComponentHidden() { return self.isComponentHidden },
    }

    const controller = controllerClass ? new controllerClass(controllerVariables) : null

    return {
      controller,
      locals,
      handlers
    }
  },
  beforeDestroy() {
    __DESTROY_CONTROLLER__

    for (const handlerArgs of this.handlers) {
      this.$off(...handlerArgs) // remove all controller registered listeners (own scope)
      this.$parent.$off(...handlerArgs) // remove all controller registered listeners (parent scope)
    }

    this.handlers = []
    this.packages = null
  },
  mounted() {
    __MOUNT_CONTROLLER__
  },
  computed: {
    Math() { return this.Aeppic.Math },
    DateTime() { return this.Aeppic.DateTime },
    Anime() { return this.Aeppic.Anime },
  },
  methods: {
    __METHODS__,
    startEditing(refName) {
      if (!this.$refs[refName]) {
        return
      }

      return this.$refs[refName].startEditing()
    },
    cancelEditing(refName) {
      if (!this.$refs[refName]) {
        return
      }

      return this.$refs[refName].cancelEditing()
    },
    saveAndStopEditing(refName) {
      if (!this.$refs[refName]) {
        return
      }

      return this.$refs[refName].saveAndStopEditing()
    },
    save(refName) {
      if (!this.$refs[refName]) {
        return
      }

      return this.$refs[refName].save()
    },
    translate(...args) { 
      return this.Aeppic.translate(...args) 
    },
    watchParam(name, cb, options) {
      if (!name) {
        return
      }

      let lastValue = undefined

      const cbWithPreCheck = (newValue, oldValue) => {
        if (Array.isArray(newValue) || lastValue !== newValue) {
          cb(newValue, oldValue)
        }

        lastValue = newValue
      }
      
      return this.$watch('params.' + name, cbWithPreCheck, options)
    }
  },
  components
}`

